module.exports = __webpack_public_path__ + "static/media/1.4e9f75d5.jpg";